import { defineComponent as _defineComponent } from 'vue'
import {
  HeadingDisplay,
  ButtonBoxDecide,
  ListDisplay,
  ButtonBoxLaunch
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
import { ProductsViewHeroBase } from './components';
import { IHero } from '@/modules/products/services/products';
import { useRouter } from 'vue-router/composables';
import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';

interface Props {
  hero: IHero;
  loading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsViewHero',
  props: {
    hero: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {


const router = useRouter();
function handleActionClick(action: string) {
  WarrenSession.set(StorageKeys.ProductCatalogType, 'fixed-income', true);

  if (action === 'CATALOG') {
    router.push({ name: 'productsCatalog' });
  }

  if (action === 'ORDERS') {
    window.location.assign(`/products/#/orders`);
  }
}

function goToTransactions() {
  router.push({ name: 'transactions' });
}

return { __sfc: true,router, handleActionClick, goToTransactions, HeadingDisplay, ButtonBoxDecide, ListDisplay, ButtonBoxLaunch, Money, ProductsViewHeroBase }
}

})